const isPlainObject = (value) => {
  return Object.prototype.toString.call(value) === '[object Object]'
}

const hasSmartCardValue = (value) => {
  if (value === undefined || value === null || value === '') return false
  if (Array.isArray(value)) return value.length > 0
  if (isPlainObject(value)) return Object.keys(value).length > 0
  return true
}

export const getNonEmptySmartCardProfile = (profile = {}) => {
  return Object.keys(profile).reduce((data, key) => {
    let value = profile[key]
    if (hasSmartCardValue(value)) {
      data[key] = value
    }
    return data
  }, {})
}

export const mergeNonEmptySmartCardData = (...dataList) => {
  return dataList.reduce((data, item = {}) => {
    return Object.keys(item || {}).reduce((newData, key) => {
      let value = item[key]
      if (!hasSmartCardValue(value)) return newData
      if (isPlainObject(value) && isPlainObject(newData[key])) {
        newData[key] = mergeNonEmptySmartCardData(newData[key], value)
      } else {
        newData[key] = value
      }
      return newData
    }, { ...data })
  }, {})
}

export const normalizeSmartCardAddressData = (
  address,
  addressTypeCode = 'CITIZEN',
) => {
  if (!address) return {}
  if (Array.isArray(address)) {
    return (
      address.find(
        (item) => item && item.addressTypeCode === addressTypeCode,
      ) ||
      address[0] ||
      {}
    )
  }

  let nestedAddress = [
    address.data,
    address.rows,
    address.items,
    address.personAddress,
    address.personAddresses,
    address.patientAddress,
    address.addresses,
  ].find((value) => hasSmartCardValue(value))
  if (nestedAddress) {
    return normalizeSmartCardAddressData(nestedAddress, addressTypeCode)
  }

  return address
}

export const mergePersonWithSmartCardProfile = (
  person = {},
  cardProfile = {},
  hn,
) => {
  return {
    ...person,
    ...getNonEmptySmartCardProfile(cardProfile),
    hn,
  }
}
